import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './styles/global.css'

document.title = '清一公社家园'

createApp(App).use(router).mount('#app')